import { Excess } from './types/excess'

export const isMainExcess = (excess: Excess) => excess.voluntaryExcessApplies
